module.exports = __webpack_public_path__ + "img/plan.5feaca47.png";